import http from './http';

export const getSites = async () => {
  const { data } = await http.get('/static');
  return data.enum.sito.nome;
};
